export default "__VITE_ASSET__CI$CEWCk__"